<template>
  <div class="share">

    <div class="address" v-if="plazaName">
      <van-icon name="location" />
      <span style="maegin-left: 2px">{{ plazaName }}</span>
    </div>

    <div class="card">
      <img class="share-img" :src="imgSrc" />

      <!-- <img id="img1" :src="require('./img/bg_share.png')" /> -->
      <vue-qr style="display: none" id="img2" class="qr-code" :text="text" :size="212" :margin="10"
        :callback="vurQrCallBack"></vue-qr>
      <div class="guide">
        <img src="./img/bg_share_hand.png" />
        <span>长按二维码保存并分享</span>
      </div>

      <canvas id="canvas" hidden width="345px" height="440px"></canvas>
    </div>

    <div class="btn share-btn" @click="handleShare">分享给朋友</div>
    <div class="btn detail-btn" @click="shareDetail">
      分享记录
    </div>

    <div class="cover" v-if="show_guide" @click="cancel">
      <img :src="guideShareIng" @click="cancel" />
    </div>
  </div>
</template>

<script>
import { ApiGetTicket } from '@/api/insurance';
import { wxSign, LinkPage, queryString } from './hooks';
import vueQr from 'vue-qr';
import { Toast } from 'vant';
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      backImg: 'url(' + require('./img/bg_share.png') + ')',
      guideShareIng: require('@/assets/img/common/guideshare.png'),
      text: '',
      show_guide: false,
      imgSrc: '',
      timer: 0,
      loading: true
    };
  },
  computed: {
    type() {
      // private Integer type; // 1-商管 2-商户
      return this.$route.query.type;
    },
    userId() {
      // id
      return this.$store.state.account.userId;
    },
    plazaId() {
      return this.$store.state.account.plazaId;
    },
    plazaName() {
      return this.$store.state.account.plazaName;
    },
    storeId() {
      return this.$store.state.account.storeId;
    },
    userIdToken() {
      // 万信号
      return this.$route.query.userIdToken;
    },
    wdSign() {
      return this.$route.query.sign;
    },
  },
  methods: {
    downloadImg() { },
    cancel() {
      this.show_guide = false;
    },

    handleShare() {
      this.show_guide = true;
    },
    shareDetail() {
      this.$router.push({
        path: '/share_detail',
        query: {
          userIdToken: this.userIdToken,
        },
      });
    },
    vurQrCallBack(url) {
      const _this = this
      
      if (!isWechat()) {
        Toast({
          type: 'fail',
          message: '请在微信内打开',
          overlay: true,
          forbidClick: true,
          duration: 0
        })
        return
      }


      Toast({
        type: 'loading',
        message: '正在生成您的专属二维码...',
        duration: 0
      })
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let img = new Image();
        img.src = require('./img/bg_share.png');
        img.onload = function () {
          const canvas = document.getElementById('canvas');
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, 345, 440);
          let img2 = document.getElementById('img2');
          ctx.drawImage(img2, 67, 148, 212, 212);
          _this.imgSrc = canvas.toDataURL();
          Toast.clear()
        };
      }, 100);
    },
  },
  async mounted() {
    let _this = this




    // let params = {
    //   shareId: this.userIdToken,
    //   shareSquareId: this.plazaId,
    //   shareType: this.type,
    //   wdSign: this.wdSign
    // };
    // this.text = LinkPage('/index', params);
    if(this.$route.path.includes('_dev')){
      this.text = `${location.origin}${location.pathname}#/insure_auth_dev?pageType=share&shareId=${this.userIdToken}&shareRoleType=${this.type}&sharePlazaId=${this.plazaId}&wdSign=${this.wdSign}`
    }else{
      this.text = `${location.origin}${location.pathname}#/insure_auth?pageType=share&shareId=${this.userIdToken}&shareRoleType=${this.type}&sharePlazaId=${this.plazaId}&wdSign=${this.wdSign}`
    }
    console.log('********this.text*********',this.text);

    let jsapi_ticket = await ApiGetTicket();
    let url = location.origin + location.pathname;
    let signature = wxSign(jsapi_ticket, url);

    window.wx.config({
      debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
      appId: localStorage.getItem('weChatOfficialAccountType') == '2' ? 'wxf91f646263070b5f' : 'wx6291bd6ded26851f', // 必填，公众号的唯一标识
      timestamp: parseInt(new Date().getTime() / 1000) + '', // 必填，生成签名的时间戳
      nonceStr: '13579246', // 必填，生成签名的随机串
      signature: signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的 JS 接口列表
    });
    window.wx.ready(function () {
      //需在用户可能点击分享按钮前就先调用
      let link = _this.text
      window.wx.updateAppMessageShareData({
        title: '万达商户专属保险', // 分享标题
        desc: '量身定制，一站式投保，线上理赔', // 分享描述
        // link: `${location.origin}${location.pathname}#/insure_linkPage?pageType=insure_suggest`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl:
          'https://wicmp.wandawic.com/sgapp-res/sgapp-static/downloads/insure_share_logo.png', // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
  },
};
</script>

<style lang="less" scoped>
.share {
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 1;
  text-align: left;

  width: 100%;
  height: 100%;
  // position: relative;
  padding: 0 15px 20px 15px;
  box-sizing: border-box;
  overflow: auto;

  .address {
    margin-top: 20px;

    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #111111;
  }

  .card {
    margin-top: 20px;
    position: relative;

    .share-img {
      width: 100%;
    }

    .qr-code {
      position: absolute;
      bottom: 81px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .guide {
      width: 200px;
      height: 41px;
      background-image: url('./img/bg_share_pao.png');
      background-size: 100% 100%;
      font-size: 14px;
      font-weight: 500;
      color: #fc9127;
      padding: 10px 0 0 22px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 13px;
        height: 14px;
        margin-right: 4px;
      }
    }
  }

  .btn {
    width: 251px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 22px;
    font-size: 16px;
    box-sizing: border-box;
    font-weight: 500;
    margin: 0 auto;
  }

  .share-btn {
    background: #ff6f00;
    color: #fff;
    margin-top: 20px;
  }

  .detail-btn {
    color: #ff6f00;
    border: 1px solid #ff6f00;
    box-sizing: border-box;
    margin-top: 12px;
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);

    img {
      position: absolute;
      top: 7px;
      right: 16px;
      height: 398px;
      width: 285px;
    }
  }
}
</style>